import { useSyncExternalStore } from "react"

type useMediaQuery = (query: string) => boolean;

function subscribe(query: string, callback: () => void) {
  const matchQueryList = window.matchMedia(query);
  matchQueryList.addEventListener("change", callback);
  return () => matchQueryList.removeEventListener("change", callback);
}

function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (callback) => subscribe(query, callback),
    () => window.matchMedia(query).matches,
    () => false,
  );
}

export default useMediaQuery;
